import { accessRank, type CompanyMeView, type PermissionKey } from '@lp/contracts';
import { useParams } from 'react-router';
import { useAuth } from './auth';

/**
 * Whose screens these are (Phase 9): the Super Admin looking at a client (/platform/clients/:id/…), or a company user in its own console
 * (/company/…). The same pages serve both; the addresses and the buttons follow the signed-in user. The server decides — this only hides
 * what would be refused.
 */
export function useScope() {
  const user = useAuth((s) => s.session?.user);
  const params = useParams();
  const company = user && 'kind' in user && user.kind === 'company' ? (user as CompanyMeView) : null;
  const clientId = company ? company.client.id : Number(params.clientId);
  return {
    company,
    clientId,
    /** the API address of this client's data */
    base: company ? '/company' : `/platform/clients/${clientId}`,
    /** the next draws of an installed product */
    schedule: (code: string, days = 3) => (company ? `/company/products/${code}/schedule?days=${days}` : `/platform/products/${code}/schedule?days=${days}`),
    /** may the signed-in user do this? the Super Admin edits, platform staff read; a company user has its permissions */
    can: (key: PermissionKey, level: 'read' | 'edit') => (company ? accessRank(company.permissions[key]) >= accessRank(level) : level === 'read' || user?.role === 'super_admin'),
    /** a user of the company itself (not of one of its accounts), or a platform user */
    companyLevel: !company || company.account == null,
  };
}
